import * as types from "./actionTypes";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const addTask = (new_task, token) => async (dispatch) => {
  dispatch({ type: types.ADD_TASK_REQUEST });
  try {
    const r = await fetch(`${API_BASE}/tasks`, {
      method: "POST",
      body: JSON.stringify(new_task),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.message || "add failed");
    dispatch({ type: types.ADD_TASK_SUCCESS, payload: data.task });
    return types.ADD_TASK_SUCCESS;
  } catch (e) {
    console.log("addTask error", e);
    dispatch({ type: types.ADD_TASK_FAILURE });
  }
};

const getTask = (token) => async (dispatch) => {
  dispatch({ type: types.GET_TASK_REQUEST });
  try {
    const r = await fetch(`${API_BASE}/tasks`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.message || "fetch failed");
    const tasks = Array.isArray(data) ? data : Array.isArray(data.tasks) ? data.tasks : [];
    dispatch({ type: types.GET_TASK_SUCCESS, payload: tasks });
    return types.GET_TASK_SUCCESS;
  } catch (e) {
    console.log("getTask error", e);
    dispatch({ type: types.GET_TASK_FAILURE, payload: [] });
  }
};

const deleteTask = (id, token) => async (dispatch) => {
  try {
    const r = await fetch(`${API_BASE}/${id}/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    await r.json();
    dispatch({ type: types.Delete_TASK, payload: id });
    return types.Delete_TASK;
  } catch (e) {
    console.log("deleteTask error", e);
  }
};

const updateTask = (id, token, payload) => async (dispatch) => {
  try {
    const r = await fetch(`${API_BASE}/${id}/edit`, {
      method: "PATCH",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await r.json();
    if (data.updated_Note) {
      dispatch({ type: types.Edit_Task, payload: data.updated_Note });
    }
    return types.Edit_Task;
  } catch (e) {
    console.log("updateTask error", e);
  }
};

export { addTask, getTask, deleteTask, updateTask };
